'use client';

import Link from 'next/link';
import { Fragment, type FC } from 'react';
import { Flex, Text } from '@eqi-investimentos/react';
import { Divider, Image } from '@chakra-ui/react';
import { useT } from '@/libs/i18n/utils/useT';
import { PATHS } from '@/config/paths';
import { useGetProgramRelated } from '@/modules/Entertainment/http/client/useGetProgramRelated';

export const ContentRelatedContent: FC<ContentRelatedContentProps> = ({
  programId,
  expanded,
}) => {
  const t = useT();

  const { data: related = [] } = useGetProgramRelated(programId, 10);

  if (related.length === 0) {
    return <></>;
  }

  return (
    <Flex
      id="relacionados"
      direction="column"
      gap="m"
      p="l"
      bg="background.brandLight"
      borderRadius="xs"
      maxH={expanded ? 'auto' : '400px'}
    >
      <Text size="2xl" color="content.primary">
        {t('screens.content.relatedContent')}
      </Text>
      <Flex flexDir="column" overflowY="scroll" overflowX="hidden" gap="m">
        {related.map(
          ({
            id,
            program_title,
            slug,
            thumb,
            title,
            published_at,
            program_type_trans,
          }) => (
            <Fragment key={id}>
              <Flex
                key={id}
                as={Link}
                href={`${PATHS.hubs.content}/${slug}`}
                gap="m"
                alignItems="center"
                justifyContent="space-between"
                pr="3xl"
              >
                <Flex flexDir="column" gap="xs">
                  <Text size="m" fontWeight="light" color="content.brand">
                    {program_title}
                  </Text>
                  <Text size="l" color="content.primary">
                    {title}
                  </Text>
                  <Text size="m" fontWeight="light" color="content.tertiary">
                    {published_at} • {program_type_trans}
                  </Text>
                </Flex>
                <Image src={thumb} alt={title} h="3rem" borderRadius="2xs" />
              </Flex>
              <Divider borderWidth="1px" borderColor="border.secondary" />
            </Fragment>
          )
        )}
      </Flex>
    </Flex>
  );
};

export type ContentRelatedContentProps = {
  programId: string;
  expanded: boolean;
};
